import CloseIcon from '@mui/icons-material/Close'
import {
  Button,
  Collapse,
  createTheme,
  ThemeProvider,
  Toolbar,
} from '@mui/material'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import { jaJP } from '@mui/material/locale'
import { SnackbarKey, SnackbarProvider } from 'notistack'
import React from 'react'
import GlobalDialog from './Dialogs'
import AppHeader from './Header'
import ScrollToTop from './ScrollToTop'
import Snackbar from './Snackbar'
import SocketIO from './Socket'

interface Props {
  window?: () => Window
  children: React.ReactElement
}

const globalTheme = createTheme(
  {
    palette: {
      primary: {
        main: '#008b8b',
        light: '#50bcbb',
        dark: '#005d5e',
        contrastText: '#fff',
      },
      secondary: {
        main: '#d50000',
        light: '#ff5131',
        dark: '#9b0000',
        contrastText: '#fff',
      },
    },
    typography: {},
    components: {
      MuiInputBase: {
        styleOverrides: {},
      },
    },
  },
  jaJP
)

export default function Layout(props: Props) {
  const notistackRef = React.createRef<any>()
  const onClickDismiss = (key: SnackbarKey) => () => {
    notistackRef.current.closeSnackbar(key)
  }
  return (
    <ThemeProvider theme={globalTheme}>
      <SnackbarProvider
        dense
        ref={notistackRef}
        maxSnack={5}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        autoHideDuration={5000}
        TransitionComponent={Collapse as any}
        action={(key) => (
          <Button
            onClick={onClickDismiss(key)}
            sx={{
              color: (theme) => theme.palette.primary.contrastText,
              width: 1,
              height: 1,
              minWidth: 0,
            }}
          >
            <CloseIcon sx={{ color: '#fff' }} />
          </Button>
        )}
      >
        <GlobalDialog />
        <SocketIO />
        <AppHeader {...props} />
        <Box
          component="main"
          sx={{
            bgcolor: 'background.default',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Toolbar id="top" />
          <Snackbar />
          <Container
            sx={{
              color: (theme) => (theme.palette.mode === 'dark' ? '#fff' : ''),
              flex: 1,
              pb: 4,
            }}
          >
            {props.children}
          </Container>
        </Box>
        <ScrollToTop />
      </SnackbarProvider>
    </ThemeProvider>
  )
}
